<template>
  <div class="content f16 viplevelinstructions" v-wechat-title="title">
    <div v-html="content"></div>
  </div>
	
</template>

<script>
  import { fenxiang } from '../../assets/common/js/config'
	export default {
		name: "viplevelinstructions",
    data () {
		  return {
		    content: '',
        title: ''
      }
    },
    mounted: function () {
		  fenxiang({path: 'instructions'})
		  this.getData()
    },
    methods: {
		  getData: function () {
		    var url = this.$ajax.getLevelDesc_URL
        this.$customRequestAjax(url).then(res => {
          if (res.data.code && res.data.list && res.data.list.length > 0) {
            this.content = res.data.list[0].content
            this.title = this.$route.meta.title = res.data.list[0].title
            window.ReactNativeWebView.postMessage(
              JSON.stringify({
                type: 'navTitle',
                title: this.title
              })
            );
          }
        })
      }
    }
	}
</script>

<style lang="scss">
  .viplevelinstructions {
    img {
      width: 100% !important;
      height: auto !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/viplevelinstructions.vue